export default {"src":"/_next/static/media/403_Leni.e9d19c6d.svg","height":241,"width":304};